/**
 * Popup Menu
 */
let scrollDown = () => {

  let module = {},
    htmlbody,
    $window,
    btnScrollDown,
    jsScrollDown,
    scrollDownAnchor,

    commetInViewport = () => {

      var windowScrollTop = $window.scrollTop();
      var windowHeight = $window.height();
      var scrollDownBlock = btnScrollDown.closest('.scroll-down-block');
      // console.log(scrollDownBlock);
      var scrollDownBlockOffset = scrollDownBlock.offset().top;
      var sensitiveAreaTop = scrollDownBlockOffset - 0.85 * windowHeight;
      var sensitiveAreaBottom = scrollDownBlockOffset + 1 * windowHeight;
      if (windowScrollTop > sensitiveAreaTop) {
        scrollDownBlock.addClass('active');
      }
      //console.log(windowScrollTop + ":" + scrollDownBlock.offset().top + ":top " + sensitiveAreaTop + ":bottom " + sensitiveAreaBottom);
    },

    onScroll = () => {
      $window.on('scroll', function (e) {
        commetInViewport();
      });
      $(document).ready(function(){
        commetInViewport();
      });
    },



    onScrollDownClick = () => {
      /**
       * Show Menu Button
       */
      var nextSection = $('.top-section').next();

      btnScrollDown.on('click', function (e) {
        e.preventDefault();
        try {
          htmlbody.animate({
            scrollTop: scrollDownAnchor.offset().top + 25
          }, 'slow');
        } catch (err) {}
      });

      jsScrollDown.on('click', function (e) {
        e.preventDefault();
        var $this = $(this);
        var attr = $this.attr('data-scroll-to-section');

        var section = (typeof attr !== "undefined") ? $(attr) : nextSection;

        try {
          htmlbody.animate({
            scrollTop: section.offset().top
          }, 'slow');
        } catch (err) {}
      });
    },

    init = () => {

      btnScrollDown = $('#btnScrollDown');
      jsScrollDown = $('.js-scroll-down');
      scrollDownAnchor = $('#scrollDownAnchor');
      if (!btnScrollDown.length) {
        return;
      }

      htmlbody = $('html,body');
      $window = $(window);

      onScrollDownClick();
      onScroll();


    };

  module.init = init;

  return module;
};

export default scrollDown();